var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.6,2.5c-3.25,0-5.9,2.66-5.9,5.9s2.66,5.9,5.9,5.9,5.9-2.66,5.9-5.9-2.66-5.9-5.9-5.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6,19.1c-3.25,0-5.9,2.66-5.9,5.9s2.66,5.9,5.9,5.9,5.9-2.66,5.9-5.9-2.66-5.9-5.9-5.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6,35.7c-3.25,0-5.9,2.66-5.9,5.9s2.66,5.9,5.9,5.9,5.9-2.66,5.9-5.9-2.66-5.9-5.9-5.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,2.5c-3.25,0-5.9,2.66-5.9,5.9s2.66,5.9,5.9,5.9,5.9-2.66,5.9-5.9-2.66-5.9-5.9-5.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,19.1c-3.25,0-5.9,2.66-5.9,5.9s2.66,5.9,5.9,5.9,5.9-2.66,5.9-5.9-2.66-5.9-5.9-5.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,35.7c-3.25,0-5.9,2.66-5.9,5.9s2.66,5.9,5.9,5.9,5.9-2.66,5.9-5.9-2.66-5.9-5.9-5.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4,2.5c-3.25,0-5.9,2.66-5.9,5.9s2.66,5.9,5.9,5.9,5.9-2.66,5.9-5.9-2.66-5.9-5.9-5.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4,19.1c-3.25,0-5.9,2.66-5.9,5.9s2.66,5.9,5.9,5.9,5.9-2.66,5.9-5.9-2.66-5.9-5.9-5.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4,35.7c-3.25,0-5.9,2.66-5.9,5.9s2.66,5.9,5.9,5.9,5.9-2.66,5.9-5.9-2.66-5.9-5.9-5.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.fc39600d9997ae1bdedd5f8318d0e1e0.svg";
export { ForwardRef as ReactComponent };